var map = {
	"./image-1.png": 79454,
	"./image-10.png": 65865,
	"./image-2.png": 83913,
	"./image-3.png": 61077,
	"./image-4.png": 56149,
	"./image-5.png": 70511,
	"./image-6-1.png": 7357,
	"./image-6-2.png": 87386,
	"./image-6-3.png": 39225,
	"./image-6.png": 93037,
	"./image-7.png": 46548,
	"./image-8.png": 59892,
	"./image-9.png": 56563
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22753;